import { TFunction } from 'i18next';
import { SavedCard } from '@/api/types/cards.types';
import { formatCardExpiry } from '@/features/Profile/sections/PaymentMethods/helpers/formatCardExpiry';

export function renderAdditionalInfo(t: TFunction, card: SavedCard) {
  if (card.isPrimary && !card.isExpired) {
    return t('pages.cabinet.main');
  }

  if (!card.isActive) {
    return t('pages.cabinet.inactive');
  }

  if (card.isExpired) {
    const expiry = formatCardExpiry(card.expiry);
    return expiry
      ? t('pages.cabinet.expired_at', { date: expiry })
      : t('pages.cabinet.expired');
  }

  return null;
}
